import React, { useEffect, useState } from 'react'
import Loader from '../Loader'
import TextBase from '../TextBase'

const ApplicationLoader = () => {
  const [exibirMensagem, setExibirMensagem] = useState<boolean>(false)

  useEffect(() => {
    setTimeout(() => setExibirMensagem(true), 1500)
  }, [])

  return (
    <Loader visible>
      {exibirMensagem && (
        <>
          <TextBase
            fontSize={18}
            fontSizeSmall={16}
            fontWeight="500"
            color="#004186"
            padding="15px 0 0"
            textAlign="center"
          >
            Carregando o Agendamento de Consultas.
          </TextBase>
          <TextBase
            color="#4F4F4F"
            fontSize={13}
            fontSizeSmall={12}
            fontWeight="400"
            display="block"
            padding="15px 0 0"
          >
            Esse carregamento pode demorar um pouco.
            <TextBase
              textAlign="center"
              color="#4F4F4F"
              fontSize={13}
              fontSizeSmall={12}
              fontWeight="500"
              display="block"
            >
              Por favor, aguarde.
            </TextBase>
          </TextBase>
        </>
      )}
    </Loader>
  )
}

export default ApplicationLoader
